// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"7d99c0e0","787":"b7ed7332"}[chunkId] + ".chunk.js";
};